import React from 'react';
import PropTypes from 'prop-types';
import { FlatButton } from 'material-ui';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { selectPerPage, selectCurrentPage, selectCount } from 'dash-front/selectors/pagination';
import { ACTION_TYPES as PAGINATION_ACTIONS } from 'dash-front/reducers/pagination';

const buttonStyle = {
    margin: 12
};

const getJumperOffset = (smaller, bigger) => {
    const nothing = smaller === undefined || bigger === undefined || bigger - smaller < 2;
    if (nothing) {
        return null;
    }
    return Math.min(bigger - smaller, 3);
};

const getValidator = lastPage => page => page <= lastPage && page >= 0;
const transformFlat = page => ({ page });

const getItems = (count, perPage, currentPage) => {
    const pagesCount = Math.ceil(count / perPage) || 0;
    const lastPage = pagesCount ? pagesCount - 1 : 0;
    const prev = [currentPage - 2, currentPage - 1].filter(p => p > 0);
    const next = [currentPage + 1, currentPage + 2].filter(p => p < lastPage);
    const prevJumper = getJumperOffset(0, prev[0]);
    const nextJumper = getJumperOffset(next[next.length - 1], lastPage);
    const pj = prevJumper ? [{ jumper: true, page: prev[0] - prevJumper }] : [];
    const nj = nextJumper ? [{ jumper: true, page: next[next.length - 1] + nextJumper }] : [];
    const validator = getValidator(lastPage);
    const start = currentPage === 0 ? [] : [{ page: 0 }];
    const end = currentPage === lastPage || !lastPage ? [] : [{ page: lastPage }];
    const items = [
        ...start,
        ...pj,
        ...prev.map(transformFlat),
        { page: currentPage },
        ...next.map(transformFlat),
        ...nj,
        ...end
    ];
    return items.filter(e => validator(e.page));
};

const Pagination = ({ count, perPage, currentPage, onChange }) => {
    const items = getItems(count, perPage, currentPage);
    return (
        <div>
            {items.map((element, index) => {
                const el = element.page;
                const isJumper = element.jumper;
                const selected = Number(el) === Number(currentPage);
                const label = el + 1;
                const onTouchTap = () => onChange(Number(el));
                return (
                    <FlatButton
                        primary={selected}
                        disabled={selected}
                        onTouchTap={onTouchTap}
                        key={index}
                        style={{ buttonStyle }}
                    >
                        {isJumper ? '...' : label}
                    </FlatButton>
                );
            })}
        </div>
    );
};

Pagination.propTypes = {
    count: PropTypes.number,
    perPage: PropTypes.number,
    currentPage: PropTypes.number,
    onChange: PropTypes.func
};

const mapStateToProps = ({ pagination }, { entity }) => ({
    count: selectCount(pagination, entity),
    perPage: selectPerPage(pagination, entity),
    currentPage: selectCurrentPage(pagination, entity)
});

const mapDispatchToProps = (dispatch, { entity, fetchFunction }) => {
    return {
        onChange: index => {
            dispatch({
                type: PAGINATION_ACTIONS.CHANGE_PAGE,
                key: entity,
                currentPage: index
            });
            fetchFunction();
        }
    };
};

const PaginationEnhanced = compose(pure, connect(mapStateToProps, mapDispatchToProps))(Pagination);

export default PaginationEnhanced;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Pagination.js
 **/